import { Rows } from './Rows';
import { ColumnFilterModal } from './ColumnFilterModal';
import { ColHeaders } from './ColumnHeaders';
import { Pagination } from './Pagination';
function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function escapeHtml(s) {
    return s
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}
class Grid {
    constructor(options) {
        var _a, _b, _c;
        this.columnOrder = {};
        this.columns = {};
        this.filterConditions = {};
        this.eventHandlers = null;
        this.pagination = null;
        this.sortColumns = [];
        this.sortColumnDirections = {};
        this.table = null;
        this.rowLookup = {};
        this.idColumn = null;
        this.dirtyRows = {};
        this.selectedRows = new Set();
        this.softDeleted = new Set();
        this.searchTerm = '';
        options.columns.forEach((col, index) => {
            this.columns[col.field] = col;
            this.columnOrder[index] = col.field;
            if (col.isId) {
                this.idColumn = col;
            }
        });
        this.data = options.data;
        this.filteredData = options.data;
        this.sortedData = this.filteredData;
        this.eventHandlers = options.eventHandlers;
        this.pagination = options.pagination ? new Pagination(options.pagination) : null;
        this.enableInstantSearch = (_a = options.enableInstantSearch) !== null && _a !== void 0 ? _a : false;
        this.searchableColumns = (_b = options.searchableColumns) !== null && _b !== void 0 ? _b : [];
        this.singleSelect = (_c = options.singleSelect) !== null && _c !== void 0 ? _c : false;
        if (this.pagination) {
            this.pagination.grid = this;
        }
        this.sortorderChanged = this.sortorderChanged.bind(this);
        this.sortData = this.sortData.bind(this);
        this.showColumnFilter = this.showColumnFilter.bind(this);
        this.filterChanged = this.filterChanged.bind(this);
        this.visibleData = this.visibleData.bind(this);
        this.rowSelectChanged = this.rowSelectChanged.bind(this);
        this.GetSelectedRows = this.GetSelectedRows.bind(this);
        this.GetSelectedRowIds = this.GetSelectedRowIds.bind(this);
        this.setDirty = this.setDirty.bind(this);
        this.InsertRow = this.InsertRow.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.paginationChanged = this.paginationChanged.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.rows = new Rows(this);
        this.colHeaders = new ColHeaders(this);
        this.filterModal = new ColumnFilterModal(this, this.filterChanged);
        if (this.idColumn) {
            let idColumn = this.idColumn;
            this.data.forEach(row => {
                this.rowLookup[row[idColumn.field]] = row;
            });
        }
    }
    InsertRow(row) {
        let idCol = this.idColumn;
        if (idCol) {
            let rawId = row[idCol.field];
            let id = String(rawId);
            if (id in this.rowLookup) {
                console.log(`Row with id ${id} already exists`);
            }
            else {
                this.rowLookup[id] = row;
                this.data.push(row);
                this.filterData();
            }
        }
    }
    showGridHeader() {
        let result = true;
        if (this.enableInstantSearch) {
            return true;
        }
        if (this.pagination) {
            return true;
        }
        return false;
    }
    showGridFooter() {
        if (this.pagination) {
            return true;
        }
        return false;
    }
    softDeleteRows(ids) {
        ids.forEach(id => {
            this.softDeleted.add(id);
        });
        this.filterData();
    }
    ;
    GetSelectedRows() {
        let result = [];
        this.selectedRows.forEach(id => {
            let row = this.rowLookup[id];
            result.push(row);
        });
        return result;
    }
    GetSelectedRowIds() {
        return this.selectedRows;
    }
    visibleData() {
        return this.sortedData;
    }
    paginationChanged() {
        if (this.rows) {
            this.rows.reRender();
            this.colHeaders.onNewPage(this.rows.fullySelectedFields());
        }
        this.applyHighlights();
    }
    SingleSelect(field, rowId) {
        this.rows.singleSelect(field, rowId);
        this.selectedRows.clear();
        this.selectedRows.add(rowId);
    }
    ClearChecks(field) {
        this.rows.clearChecks(field);
        this.selectedRows.clear();
    }
    selectAll(field, checked) {
        this.rows.selectAll(field, checked);
    }
    render(rootElt) {
        if (!rootElt) {
            console.error("Grid render called with null root element.");
            return;
        }
        if (this.pagination) {
            this.pagination.update(this.visibleData());
        }
        let container = document.createElement('div');
        container.classList.add('dwc-datagrid-container');
        if (this.showGridHeader()) {
            let headerControls = this._renderHeaderControls();
            container.appendChild(headerControls);
        }
        let table = document.createElement('table');
        table.classList.add('dwc-datagrid-table');
        table.appendChild(this.colHeaders.render());
        table.appendChild(this.rows.render());
        container.appendChild(table);
        if (this.showGridFooter()) {
            let footer = this._renderFooter();
            container.appendChild(footer);
        }
        rootElt.appendChild(container);
        if (!document.body.contains(this.filterModal.modal)) {
            const modal = this.filterModal.render();
            if (modal) {
                document.body.appendChild(modal);
            }
        }
        this.table = table;
        this.applyHighlights();
    }
    _renderFooter() {
        const footer = document.createElement('div');
        footer.classList.add('dwc-datagrid-footer');
        if (this.pagination) {
            const pageButtons = this.pagination.RenderPageButtons();
            footer.appendChild(pageButtons);
            const pageCounter = this.pagination.RenderPageCounter();
            footer.appendChild(pageCounter);
        }
        return footer;
    }
    _renderHeaderControls() {
        const headerControls = document.createElement('div');
        headerControls.classList.add('dwc-datagrid-header-controls');
        // INSTANT SEARCH BAR
        if (this.enableInstantSearch) {
            const searchInput = document.createElement('input');
            searchInput.type = 'text';
            searchInput.placeholder = 'Search...';
            searchInput.classList.add('dwc-datagrid-search-bar');
            searchInput.addEventListener('input', (e) => {
                const input = e.target;
                this.searchTerm = input.value.toLowerCase();
                this.filterData();
            });
            headerControls.appendChild(searchInput);
        }
        if (this.pagination) {
            const topControls = this.pagination.RenderPageSizeSelect();
            headerControls.appendChild(topControls);
        }
        return headerControls;
    }
    highlightCell(field, raw) {
        const v = raw === null || raw === undefined ? "" : String(raw);
        const col = this.columns[field];
        const searchableFields = new Set(this.getSearchFields());
        const shouldHighlight = !!this.searchTerm &&
            searchableFields.has(field) &&
            (col === null || col === void 0 ? void 0 : col.dataType) === 'text';
        if (!shouldHighlight) {
            return escapeHtml(v);
        }
        const re = new RegExp(`(${escapeRegExp(this.searchTerm)})`, "gi");
        return escapeHtml(v).replace(re, "<mark>$1</mark>");
    }
    applyHighlights() {
        if (!this.table)
            return;
        const columns = this.orderColumns();
        const searchable = new Set(this.getSearchFields());
        const highlightIndexes = [];
        columns.forEach((c, idx) => {
            if (searchable.has(c.field) && c.dataType === 'text') {
                highlightIndexes.push(idx);
            }
        });
        if (highlightIndexes.length === 0)
            return;
        const tbodies = Array.from(this.table.tBodies);
        tbodies.forEach(tbody => {
            Array.from(tbody.rows).forEach(tr => {
                highlightIndexes.forEach(ix => {
                    var _a;
                    const td = tr.cells[ix];
                    if (!td)
                        return;
                    const raw = (_a = td.textContent) !== null && _a !== void 0 ? _a : '';
                    td.innerHTML = this.highlightCell(columns[ix].field, raw);
                });
            });
        });
    }
    orderColumns() {
        let columns = [];
        Object.keys(this.columnOrder).forEach(index => {
            let ix = Number(index);
            let field = this.columnOrder[ix];
            columns.push(this.columns[field]);
        });
        return columns;
    }
    filterChanged(field, filterConditions) {
        if (filterConditions.length === 0) {
            delete this.filterConditions[field];
        }
        else {
            this.filterConditions[field] = filterConditions;
        }
        this.filterData();
    }
    filterData() {
        let rows = this.cloneBaseData();
        rows = this.excludeSoftDeleted(rows);
        rows = this.applyColumnFilters(rows);
        rows = this.applyInstantSearch(rows);
        this.commitFilter(rows);
    }
    cloneBaseData() {
        return this.data.slice();
    }
    excludeSoftDeleted(rows) {
        if (!this.idColumn || this.softDeleted.size === 0)
            return rows;
        let idColumn = this.idColumn;
        return rows.filter(r => !this.softDeleted.has(String(r[idColumn.field])));
    }
    applyColumnFilters(rows) {
        let fields = Object.keys(this.filterConditions);
        if (fields.length === 0)
            return rows;
        let output = rows;
        for (let field of fields) {
            let conditions = this.filterConditions[field] || [];
            if (conditions.length === 0)
                continue;
            output = output.filter(row => this.rowMatchesAnyCondition(row, conditions));
        }
        return output;
    }
    rowMatchesAnyCondition(row, conditions) {
        for (let cond of conditions) {
            if (cond.apply(row))
                return true;
        }
        return false;
    }
    applyInstantSearch(rows) {
        var _a;
        let needle = (_a = this.searchTerm) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
        if (!needle)
            return rows;
        let fields = this.getSearchFields();
        return rows.filter(row => this.rowMatchesSearch(row, fields, needle));
    }
    getSearchFields() {
        return (this.searchableColumns && this.searchableColumns.length > 0)
            ? this.searchableColumns
            : Object.keys(this.columns);
    }
    rowMatchesSearch(row, fields, needle) {
        for (let f of fields) {
            let v = row === null || row === void 0 ? void 0 : row[f];
            if (v !== null && v !== undefined && String(v).toLowerCase().includes(needle)) {
                return true;
            }
        }
        return false;
    }
    commitFilter(rows) {
        this.filteredData = rows;
        this.sortData();
        if (this.pagination) {
            this.pagination.page = 0;
            this.pagination.update(this.sortedData);
        }
        this.rows.reRender();
        this.applyHighlights();
    }
    isSingleSelect() {
        return this.singleSelect;
    }
    showColumnFilter(field) {
        let filterContitions = this.filterConditions[field];
        if (!filterContitions) {
            filterContitions = [];
            this.filterConditions[field] = filterContitions;
        }
        this.filterModal.showModal(field);
    }
    rowSelectChanged(id, checked, colDef) {
        var _a;
        let field = colDef.field;
        let strId = String(id);
        if (checked) {
            if (this.singleSelect) {
                this.rows.singleSelect(field, strId);
                this.selectedRows.clear();
            }
            this.selectedRows.add(strId);
        }
        else {
            this.selectedRows.delete(strId);
        }
        if ((_a = this.eventHandlers) === null || _a === void 0 ? void 0 : _a.onRowSelect) {
            this.eventHandlers.onRowSelect(id, checked);
        }
        ;
    }
    changeValue(id, field, value, input) {
        var _a;
        let strId = String(id);
        let row = this.rowLookup[strId];
        let colDef = this.columns[field];
        let val = value;
        if (colDef.pattern) {
            let regex = new RegExp(colDef.pattern);
            if (!regex.test(value)) {
                return;
            }
        }
        if (colDef.dataType === 'number') {
            val = Number(value);
        }
        else if (colDef.dataType === 'datetime') {
            val = new Date(value);
        }
        if (row) {
            if ((_a = this.eventHandlers) === null || _a === void 0 ? void 0 : _a.onRowChanging) {
                this.eventHandlers.onRowChanging(id, field, val, row);
            }
            row[field] = val;
            this.setDirty(id, field);
            input.classList.remove('dwc-datagrid-cell-dirty');
        }
    }
    setDirty(id, field) {
        var _a;
        let strId = String(id);
        if (!(strId in this.dirtyRows)) {
            this.dirtyRows[strId] = new Set();
        }
        this.dirtyRows[strId].add(field);
        if ((_a = this.eventHandlers) === null || _a === void 0 ? void 0 : _a.onDataModified) {
            this.eventHandlers.onDataModified(id, field);
        }
    }
    sortorderChanged(field, order, shiftKey) {
        var _a, _b;
        (_a = this.table) === null || _a === void 0 ? void 0 : _a.classList.add('sorting');
        if (!shiftKey) {
            this.sortColumns = [];
        }
        let newCols = this.sortColumns.filter(item => item !== field);
        switch (order) {
            case 'ascending':
                newCols.push(field);
                this.sortColumnDirections[field] = 'ascending';
                break;
            case 'descending':
                newCols.push(field);
                this.sortColumnDirections[field] = 'descending';
                break;
            default:
                this.sortColumnDirections[field] = 'none';
                break;
        }
        this.sortColumns = newCols;
        this.sortData();
        (_b = this.table) === null || _b === void 0 ? void 0 : _b.classList.remove('sorting');
    }
    sortData() {
        let sortedData = this.filteredData.slice();
        if (this.sortColumns.length > 0) {
            sortedData.sort((a, b) => {
                if (a === b) {
                    return 0;
                }
                if (a === null || a === undefined) {
                    return b === null || b === undefined ? 0 : -1;
                }
                let result = 0;
                this.sortColumns.forEach(field => {
                    if (!result) {
                        let direction = this.sortColumnDirections[field];
                        if (direction != "ascending" && direction != "descending") {
                            return;
                        }
                        let col = this.columns[field];
                        let va = a[col.field];
                        let vb = b[col.field];
                        if (direction === 'descending') {
                            let t = va;
                            va = vb;
                            vb = t;
                        }
                        if (col.dataType === 'datetime') {
                            va = new Date(va).getTime();
                            vb = new Date(vb).getTime();
                        }
                        else if (col.dataType === 'date') {
                            va = new Date(va).getTime();
                            vb = new Date(vb).getTime();
                        }
                        else if (col.dataType === 'number') {
                            va = Number(va);
                            vb = Number(vb);
                        }
                        else if (col.dataType === 'hyperlink' && (va === null || va === void 0 ? void 0 : va.text) && (vb === null || vb === void 0 ? void 0 : vb.text)) {
                            va = va.text;
                            vb = vb.text;
                        }
                        else if (col.dataType === 'checkSelect') {
                            va = va ? 1 : 0;
                            vb = vb ? 1 : 0;
                        }
                        if (va < vb) {
                            return result = -1;
                        }
                        else if (va > vb) {
                            result = 1;
                        }
                    }
                });
                return result;
            });
        }
        this.sortedData = sortedData;
        this.rows.reRender();
        if (this.pagination) {
            this.pagination.update(this.sortedData);
        }
        this.applyHighlights();
    }
    clearFilter(field) {
        delete this.filterConditions[field];
        this.filterData();
        if (this.rows && typeof this.rows.reRender === 'function') {
            this.rows.reRender();
        }
        if (this.pagination) {
            this.pagination.page = 0;
            this.pagination.update(this.sortedData);
        }
        this.applyHighlights();
    }
    refresh() {
        this.rows.reRender();
        if (this.pagination) {
            this.pagination.update(this.sortedData);
        }
        this.applyHighlights();
    }
}
export default Grid;
